import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentResultsTableComponent } from './document-results-table/document-results-table.component';

@Component({
  selector: 'eca-app-session-diagnostics',
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.css'],
  imports: [DocumentResultsTableComponent]
})
export class DiagnosticsComponent implements OnInit {
  private _route = inject(ActivatedRoute);

  sessionId: string;

  ngOnInit() {
    this.sessionId = this._route.snapshot.params.sessionId;
  }

}
